// This file provides a polyfill for the Node.js process object in the browser
window.process = {
  env: {
    NODE_ENV: process.env.NODE_ENV || 'development',
    // Add any other environment variables your app needs
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    // Add other REACT_APP_* variables as needed
  }
};

export default window.process; 